import script from "./SelectYear.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectYear.vue?vue&type=script&setup=true&lang=js"

import "./SelectYear.vue?vue&type=style&index=0&id=53521631&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53521631"]])

export default __exports__